module.exports = __webpack_public_path__ + "media/application/images/icons/icon-building-3a0cef58a7b0a82e0a8bbd49e02e1dd6.svg";